import angular from 'angular';

angular
  .module('cxSettings')
  .controller('EditInteractionTemplateSettingsCtrl', [
    '$state',
    '$timeout',
    '$q',
    '$translate',
    'interactionTemplateHttpSvc',
    'flySvc',
    'dataCache',
    'dialogsSvc',
    'ModalService',
    '$http',
    'appUrls',
    'template',
    'companyId',
    'enumCacheSvc',
    '$filter',
    'checkSecurity',
    'type',
    editInteractionTemplateSettingsCtrl,
  ]);

function editInteractionTemplateSettingsCtrl(
  $state,
  $timeout,
  $q,
  $translate,
  interactionTemplateHttpSvc,
  flySvc,
  dataCache,
  dialogsSvc,
  ModalService,
  $http,
  appUrls,
  template,
  companyId,
  enumCacheSvc,
  $filter,
  checkSecurity,
  type,
) {
  var vm = this;
  vm.dataCache = dataCache;
  vm.tags = [];
  vm.template = template || {
    name: '',
    type: type,
    languages: [],
    companyId: companyId,
  };
  vm.validation = {};

  switch (type) {
    case 0:
      vm.typeName = 'NoteTemplates';
      break;
    case 3:
      vm.typeName = 'MeetingTemplates';
      break;
    case 1:
      vm.typeName = 'PhoneTemplates';
      break;
    default:
      vm.typeName = 'NoteTemplates';
      break;
  }

  var retrieveInteractionTags = function() {
    $http
      .get(appUrls.interactions + '/api/tags')
      .then(function(response) {
        var result = response.data;
        vm.tags = result;
      })
      .catch(function(error) {
        showError(error);
      });
  };

  if (checkSecurity(['Settings:u', 'EmailAndInteractionTemplates:u'])) {
    retrieveInteractionTags();
  }

  vm.filterTags = function(search) {
    return $filter('filter')(vm.tags, search);
  };

  vm.updateValue = () => {};

  vm.translation = {};
  vm.collapsed = [];
  vm.languages = dataCache.getArray('language');

  vm.saving = false;

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
  };

  vm.toggleOpen = function(lang) {
    vm.collapsed[lang.languageCode] = !vm.collapsed[lang.languageCode];
  };

  vm.gotoList = function() {
    if (vm.form && vm.form.$dirty) {
      vm.form.$rollbackViewValue();
      vm.form.$setPristine();
    }
    let goToTab = 0;
    switch (type) {
      case 0:
        goToTab = 'NoteTemplates';
        break;
      case 3:
        goToTab = 'MeetingTemplates';
        break;
      case 1:
        goToTab = 'PhoneTemplates';
        break;
      default:
        break;
    }
    $state.go('settings.interactiontemplates', {
      tab: goToTab,
    });
  };
  vm.isValid = function() {
    if (!vm.template || !vm.form.$valid) return false;
    if (!vm.template.companyId) return false;

    return true;
  };
  var sortLanguages = function() {
    if (!vm.template || !vm.template.languages) return;
    var currentLang = $translate.use().split('-')[0];
    vm.template.languages.sort(function(a, b) {
      if (a.languageCode === currentLang) return -1;
      if (b.languageCode === currentLang) return 1;
      if (a.languageCode < b.languageCode) return -1;
      if (a.languageCode > b.languageCode) return 1;
      return 0;
    });
  };
  sortLanguages();

  vm.removeLanguage = function(lang) {
    var idx = vm.template.languages.indexOf(lang);
    if (idx < 0) return;
    dialogsSvc.showYesNo('comfirmDeleteTitle', 'comfirmDeleteTranslation').then(function() {
      if (vm.template.id && !lang.isNew)
        interactionTemplateHttpSvc
          .removeLanguage(vm.template.id, lang.languageCode)
          .then(function() {
            vm.template.languages.splice(idx, 1);
          });
      else vm.template.languages.splice(idx, 1);
    });
  };

  var saveLanguages = function() {
    if (!vm.template.id) return $q.reject();
    return $q.all(
      vm.template.languages
        // .filter(function(lang) {
        //   return vm.form['lang_' + lang.languageCode].$dirty;
        // })
        .map(function(lang) {
          return !lang.isNew
            ? interactionTemplateHttpSvc.updateLanguage(vm.template.id, lang)
            : interactionTemplateHttpSvc.createLanguage(vm.template.id, lang);
        }),
    );
  };

  let mapValidationError = x => {
    let message = $filter('translateList')(
      x.type,
      'templatevalidationwarningtype',
      x.type,
      x.parameters,
    );
    if (!!x.taskName) {
      if (!!x.subTaskName) {
        return (
          $translate.instant('TaskTemplate') +
          ' ' +
          x.taskName +
          '/' +
          x.subTaskName +
          ' ' +
          message
        );
      }
      return $translate.instant('TaskTemplate') + ' ' + x.taskName + ' ' + message;
    }
    return message;
  };

  var validateLanguages = function() {
    if (!vm.template.id) return $q.reject();
    return $q.all(
      vm.template.languages.map(lang =>
        interactionTemplateHttpSvc.validateLanguage(vm.template.id, lang).then(
          data => {
            if (!data || data.length === 0) {
              delete vm.validation[lang.languageCode];
            } else {
              vm.validation[lang.languageCode] = data.map(x => mapValidationError(x)).join('\n');
            }
          },
          error => {
            flySvc.error(error);
          },
        ),
      ),
    );
  };

  var saveTranslations = function() {
    if (!vm.translation || !vm.translation.save) return $q.when();
    return vm.translation.save(vm.template.id);
  };

  vm.validate = (saveFirst = false) => {
    $timeout(function() {
      vm.validating = true;
      if (saveFirst) {
        return vm.save(false, false).finally(() => {
          vm.validating = false;
        });
      }
      vm.validating = false;
    }, 0);
  };

  vm.save = function(navigateAway = true, showSuccess = true) {
    var deferred = $q.defer();
    $timeout(function() {
      if (!vm.isValid() || vm.saving) return deferred.reject();
      if (vm.translation && !vm.translation.isValid(true)) return deferred.reject();
      vm.saving = true;
      if (vm.template.id) {
        $q.all([saveLanguages(), saveTranslations()])
          .then(function() {
            // if (vm.form.template.$dirty) {
            const model = {
              ...vm.template,
              interactionTags: vm.template.interactionTags
                ? vm.template.interactionTags.map(x => x.id)
                : [],
            };
            return interactionTemplateHttpSvc.updateTemplate(model);
            //}
            return $q.resolve();
          })
          .then(
            function() {
              vm.saving = false;
              deferred.resolve();
              if (showSuccess) flySvc.success();
              if (navigateAway) vm.gotoList();
            },
            function(errors) {
              flySvc.error(errors);
              deferred.reject();
              vm.saving = false;
            },
          );
      } else {
        const model = {
          ...vm.template,
          interactionTags: vm.template.interactionTags
            ? vm.template.interactionTags.map(x => x.id)
            : [],
        };
        interactionTemplateHttpSvc.createTemplate(vm.template.companyId, model).then(
          function(template) {
            vm.template.id = template.id;
            $q.all([saveLanguages(), saveTranslations()]).then(
              function() {
                vm.template.languages.forEach(x => (x.isNew = false));
                template.languages = vm.template.languages;
                vm.saving = false;
                deferred.resolve();
                if (showSuccess) flySvc.success();
                if (navigateAway) vm.gotoList();
              },
              function(errors) {
                //todo: check error response
                deferred.reject();
                vm.saving = false;
              },
            );
          },
          function(error) {
            deferred.reject();
            showError(error);
            vm.saving = false;
          },
        );
      }
    }, 0);

    return deferred.promise;
  };
  vm.addLanguage = function(langCode) {
    if (!langCode) return;
    vm.template.languages.push({
      languageCode: langCode,
      content: '',
      title: '',
      isNew: true,
    });
    sortLanguages();
  };

  vm.filterLanguages = function(lang) {
    if (vm.template == null) return true;
    for (var i = 0; i < vm.template.languages.length; i++)
      if (vm.template.languages[i].languageCode === lang.code) return false;
    return true;
  };

  vm.updateName = function(value) {
    vm.template.name = value;
  };
}
